import { get, post, del } from 'aws-amplify/api';

const API_NAME = 'coreuser';  // Using same API as userattributes
const BASE_PATH = '/core/limits';

/**
 * Get all bet limits for a user
 * @param {string} username - Username to get limits for
 * @returns {Promise<Object>} Response with limits array
 */
export const fetchBetLimits = async (username) => {
  try {
    const response = await get({
      apiName: API_NAME,
      path: `${BASE_PATH}/${username}`
    }).response;
    
    const data = await response.body.json();
    console.log('Fetched bet limits:', data);
    return data;
  } catch (error) {
    console.error('Error fetching bet limits:', error);
    return {
      success: false,
      limits: [],
      error: error.message
    };
  }
};

/**
 * Save or update a single bet limit
 * @param {string} username - Username to save limit for
 * @param {Object} limit - Limit object with gameId, currency, maxBet
 * @param {string} userType - Type of user (agent or player)
 * @returns {Promise<Object>} Response with saved limit
 */
export const saveBetLimit = async (username, limit, userType = null) => {
  try {
    const response = await post({
      apiName: API_NAME,
      path: `${BASE_PATH}/${username}`,
      options: {
        body: {
          limit,
          userType
        }
      }
    }).response;
    
    const data = await response.body.json();
    console.log('Saved bet limit:', data);
    return data;
  } catch (error) {
    console.error('Error saving bet limit:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Save multiple bet limits at once
 * @param {string} username - Username to save limits for
 * @param {Array} limits - Array of limit objects
 * @param {string} userType - Type of user (agent or player)
 * @returns {Promise<Object>} Response with saved limits
 */
export const saveBulkBetLimits = async (username, limits, userType = null) => {
  try {
    const response = await post({
      apiName: API_NAME,
      path: `${BASE_PATH}/${username}/bulk`,
      options: {
        body: {
          limits,
          userType
        }
      }
    }).response;
    
    const data = await response.body.json();
    console.log('Saved bulk bet limits:', data);
    return data;
  } catch (error) {
    console.error('Error saving bulk bet limits:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Delete a bet limit
 * @param {string} username - Username to delete limit for
 * @param {string} limitId - ID of the limit to delete
 * @returns {Promise<Object>} Response with success status
 */
export const deleteBetLimit = async (username, limitId) => {
  try {
    const response = await del({
      apiName: API_NAME,
      path: `${BASE_PATH}/${username}/${limitId}`
    }).response;
    
    const data = await response.body.json();
    console.log('Deleted bet limit:', data);
    return data;
  } catch (error) {
    console.error('Error deleting bet limit:', error);
    return {
      success: false,
      error: error.message
    };
  }
};
